import { render, staticRenderFns } from "./AnomalyCard.vue?vue&type=template&id=7f36af9c&scoped=true"
import script from "./AnomalyCard.vue?vue&type=script&lang=js"
export * from "./AnomalyCard.vue?vue&type=script&lang=js"
import style0 from "./AnomalyCard.vue?vue&type=style&index=0&id=7f36af9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f36af9c",
  null
  
)

export default component.exports